class CollectionLockModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    document.body.classList.toggle('util-SiteOverflowed', true)

    this.setAttribute('aria-hidden', 'false')
  }

  setupListeners () {
    this.handleSubmit = this.handleSubmit.bind(this)

    if (this.els?.submit?.element) {
      this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)
    }
  }

  async handleSubmit (event) {
    event.preventDefault()

    const formData = new FormData(this.els.form.element)
    const catalogueCode = formData.get('collection_lock_password')

    if (!catalogueCode) return

    await this.setCartAttribute(this.cartAttributeKey, catalogueCode)

    window.location.reload()
  }

  resetError () {
    this.setCartAttribute(this.cartAttributeKey, '')
  }

  setCartAttribute (attributeKey, attributeValue) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeKey]: attributeValue,
        },
      }),
    })
  }

  get cartAttributeKey () {
    return `password_submitted`
  }
}

if (!customElements.get('collection-lock-modal')) {
  customElements.define('collection-lock-modal', CollectionLockModal)
}
